export const pkg = {
  name: 'isomorphic-git',
  version: '1.44.10',
  agent: 'git/isomorphic-git@1.44.10',
}
